import { Fragment } from 'react';
import { BgPlaceholder, PlaceholderType } from '~/components/ui/BgPlaceholder';
import { ShopShadow } from '~/components/ui/ShopShadow';
import { rage } from '~/rage';

const Background = () => (
	<Fragment>
		{rage.config.isStub() && (
			<BgPlaceholder $type={PlaceholderType.VehicleService} />
		)}
		<ShopShadow />
	</Fragment>
);

export { Background };
